import React from "react";
import Skeleton from "react-loading-skeleton";
import { toFarsiNumber } from "../../helper/helper";

const AcademyCardLoading = () => {
  return (
    <div
      to={"/academy-page"}
      className="w-full h-auto flex flex-col gap-3 group bg-[#222222] overflow-hidden rounded-xl"
    >
      {/* thumbnail */}
      <div className="overflow-hidden h-[168px] rounded-xl">
        <Skeleton className="h-[168px] block w-full rounded-b-xl" />
      </div>

      <div className="flex flex-col gap-4 px-3 pb-3">
        {/* categories */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-7 block w-20 rounded-lg" />
          <Skeleton className="h-7 block w-36 rounded-lg" />
        </div>

        {/* title */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-10 block w-56 rounded-lg -mt-6 -mb-6" />
        </div>

        {/* description */}
        <p className="line-clamp-2 text-sm leading-6 text-gray-600">
          <Skeleton className="w-full h-5 block rounded-lg" />
          <Skeleton className="w-full h-5 block rounded-lg -mt-3" />
        </p>

        <div className="pb-3 border-b border-gray-800">
          <Skeleton className="w-full h-7 block rounded-lg -mt-5 -mb-5" />
        </div>

        <div className="block">
          <Skeleton className="w-full h-7 block rounded-lg -mt-2 -mb-5" />
        </div>
      </div>
    </div>
  );
};

export default AcademyCardLoading;
